import * as React from 'react';

import { cn } from '@/lib/utils/cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn('skeleton-shimmer rounded-md', className)}
      aria-hidden
      {...props}
    />
  );
}

export { Skeleton };
